import { combineReducers } from "redux";

// Imports reducers files
import auth from "./auth";
import user from "./user";
import department from "./department";
import request from "./request";
import todo from "./todo";
import assets from "./asset";
import assignmentReducer from "./assignmentReducer";
import chat from "./chat";
import configurationReducer from "./configurationReducer";
import performance from "./performance";
import onboarding from "./onboarding";
import overview from "./overview";
import bookingTemplate from "./bookingtemplate";
import booking from "./booking";
import tempWindowsData from "./tempWindowsData";
import billing from "./billing";
import emailNotification from "./emailNotification";
import manageComponent from "./manageComponent"
import clientSecret from "./clientSecret"
import todoPerformance from "./todoPerformance"
import sidebar from "./sidebar";
import collaboratorOrCustomer from "./collaboratorOrCustomer";
import customizedTable from "./customizedTable"
import analytics from "./analytics";
import skuMaster from "./skuMaster";
import productMaster from "./productMaster"
import purchaseOrder from "./purchaseOrder";
import productionOrder from "./productionOrder";
import salesOrder from "./salesOrder";
import correctionOrder from "./correctionOrder";
import inventory from "./inventory";
import path from "./path";
import palettes from "./palettes";

const rootReducer = combineReducers({
  auth,
  user,
  request,
  todo,
  assets,
  assignmentReducer,
  department,
  configurationReducer,
  onboarding,
  overview,
  bookingTemplate,
  chat,
  performance,
  booking,
  tempWindowsData,
  billing,
  emailNotification,
  manageComponent,
  clientSecret,
  todoPerformance,
  sidebar,
  collaboratorOrCustomer,
  customizedTable,
  analytics,
  skuMaster,
  productMaster,
  purchaseOrder,
  productionOrder,
  salesOrder,
  correctionOrder,
  inventory,
  path,
  palettes
});

export default rootReducer;
